<div>
    <div class="card-header d-flex flex-row align-items-center justify-content-between">
        <h6 class="font-weight-bold text-primary">Send WhatsApp</h6>
        <button type="button" class="btn btn-danger" style="float: right;" (click)="modalRef.hide()">X</button>
    </div>
    <div class="card-body">
        <div class="form-group row">
            <div class="col-sm-6">
                <mat-form-field>
                    <input matInput type="text" readonly class="field-full-width" name="toName" [(ngModel)]="sendWhatsApp.toName" placeholder="Name">
                </mat-form-field>
            </div>
            <div class="col-sm-6">
                <mat-form-field>
                    <input matInput type="text" readonly class="field-full-width" name="toNumber" [(ngModel)]="sendWhatsApp.toNumber" placeholder="Number">
                </mat-form-field>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-12">
                <mat-form-field>
                    <mat-select class="field-full-width" placeholder="Template" [(ngModel)]="sendWhatsApp.templateId" (selectionChange)="onTemplateSelect($event.value)">
                        <mat-option *ngFor="let stat of tblWhatsAppTemplate" [value]="stat.templateId">{{stat.templateName}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-12">
                <mat-form-field>
                    <textarea matInput type="text" class="field-full-width" name="message" [(ngModel)]="sendWhatsApp.message" placeholder="Message" Rows="3">OK</textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="form-group row" *ngIf="sendWhatsApp.fileAllowed=='Yes'">
            <div class="col-sm-12">
                <button type="button" mat-raised-button (click)="fileInput.click()">Choose File</button>
                <!-- <input hidden (change)="onFileSelected($event)" #fileInput type="file"> -->
                <input hidden type="file" #fileUploader (change)="handleFileInput($event.target.files)" accept="application/pdf" />
                <span class="file-name">{{selectedFile?.name}}</span>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <button type="button" class="btn btn-primary block" (click)="sendWhatsAppMessage()">Send WhatsApp</button>
    </div>
</div>